export function exportToCSV(key: string, rows: Record<string, any>[]): void {
  if (!rows || rows.length === 0) return;

  const escape = (value: any): string => {
    if (value === null || value === undefined) return "";
    const str = String(value).replace(/"/g, '""');
    return `"${str}"`;
  };

  const headers = Object.keys(rows[0]);
  const csvRows = rows.map((row) =>
    headers.map((header) => escape(row[header])).join(",")
  );

  const csvContent = [headers.join(","), ...csvRows].join("\n");

  // Add UTF-8 BOM for Excel compatibility
  const blob = new Blob(["\uFEFF" + csvContent], {
    type: "text/csv;charset=utf-8;",
  });

  const timestamp = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
  const filename = `${key}_export_${timestamp}.csv`;

  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.setAttribute("download", filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}
